'use client';

// An epoch also invalidates requests when the same account signs out and back in.
let identity: { uid: string | null; epoch: number } = { uid: null, epoch: 0 };
const listeners = new Set<() => void>();
export function setReaderClientIdentity(uid: string | null) {
  if (identity.uid !== uid) {
    identity = { uid, epoch: identity.epoch + 1 };
    for (const listener of listeners) listener();
  }
  return identity;
}
export function readerClientIdentity() { return { ...identity }; }
export function assertReaderIdentity(snapshot: ReturnType<typeof readerClientIdentity>) {
  if (!snapshot.uid || snapshot.uid !== identity.uid || snapshot.epoch !== identity.epoch) {
    throw new Error('The signed-in account changed. Open the reader again to continue.');
  }
}
export function subscribeReaderIdentity(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
